export default function CreateInfluencerProfilePage() {
  return (
    <section className="section-padding bg-light">
      <div className="container px-4 sm:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="mb-8">
            <h1 className="text-4xl font-bold text-dark mb-4">How to create your profile</h1>
            <p className="text-xl text-gray-600 font-dm-sans">
              Build a professional influencer profile and media kit in one shareable link with InfluenceHub.
            </p>
          </div>
          <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-lg prose prose-lg max-w-none">
            <p className="text-gray-600 mb-4">
              Sign up for free, add your platforms and stats, and get a clean, public profile link you can share with any brand. No design skills required.
            </p>
            <p className="text-gray-600 mb-6">
              Your creator profile showcases your niche, audience demographics, and past brand collaborations, all in one place.
            </p>
            <a href="/signup" className="inline-flex items-center justify-center rounded-xl px-6 py-3 text-base font-semibold text-white bg-primary hover:bg-primary/90 transition font-dm-sans">
              Create your profile →
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
